import React from 'react';
import { SectionHeading, smallInputCls, inputCls } from './ui.jsx';
import { DURATION_OPTIONS } from './constants.js';
import { formatHourLabel } from './slots.js';

// onDurationRequest is called with the newly picked value; the coordinator
// decides whether to apply it (after the confirmation modal) or drop it, so the
// select stays controlled by the committed durationMinutes.
export default function AppointmentRulesSection({
  durationMinutes, onDurationRequest,
  startHour, setStartHour, endHour, setEndHour,
  maxBookingDaysOut, setMaxBookingDaysOut, timezone,
}) {
  return (
    <div className="space-y-4">
      <SectionHeading title="Appointment details" />

      <div className="space-y-1">
        <label className="block text-xs font-semibold text-white/70">
          Appointment duration <span className="text-rose-400">*</span>
        </label>
        <select
          data-testid="booking-page-select-time-slot-length"
          value={durationMinutes}
          onChange={(e) => onDurationRequest(Number(e.target.value))}
          className={inputCls}
        >
          {DURATION_OPTIONS.map((m) => (
            <option key={m} value={m}>{m} minutes</option>
          ))}
        </select>
      </div>

      <div className="space-y-1">
        <div className="text-xs font-semibold text-white/80">Hours available for appointments</div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="block text-[11px] text-white/50">
              Start time <span className="text-rose-400">*</span>
            </label>
            <select
              data-testid="booking-page-start-hour"
              value={startHour}
              onChange={(e) => setStartHour(Number(e.target.value))}
              className={smallInputCls}
            >
              {Array.from({ length: 24 }).map((_, i) => (
                <option key={i} value={i}>{formatHourLabel(i)}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-[11px] text-white/50">
              End time <span className="text-rose-400">*</span>
            </label>
            <select
              data-testid="booking-page-end-hour"
              value={endHour}
              onChange={(e) => setEndHour(Number(e.target.value))}
              className={smallInputCls}
            >
              {Array.from({ length: 24 }).map((_, i) => (
                <option key={i + 1} value={i + 1}>{formatHourLabel(i + 1)}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="text-[11px] text-white/40 pt-0.5">(time zone is {timezone || 'US/Mountain'})</div>
      </div>

      <div className="space-y-1">
        <div className="text-xs font-semibold text-white/80">Maximum booking days out</div>
        <p className="text-[11px] text-white/50">
          How many days out should your leads be able to book an appointment?
        </p>
        <div className="flex items-center w-36 rounded border border-white/15 bg-[#140b22] overflow-hidden focus-within:border-civix-cyan">
          <input
            type="text"
            maxLength={3}
            data-testid="booking-page-max-booking-days-out"
            value={maxBookingDaysOut}
            onChange={(e) => setMaxBookingDaysOut(Number(e.target.value.replace(/\D/g, '')) || 0)}
            className="w-20 px-3 py-1.5 text-xs text-white bg-transparent outline-none"
          />
          <span className="px-2.5 py-1.5 text-xs text-white/50 bg-white/5 border-l border-white/15 select-none">
            days
          </span>
        </div>
      </div>
    </div>
  );
}
